import { Durations } from '@Front/constants';
import { bounce } from '@Animations';
import { TOOLTIP_NUDGE_INTERVAL, selectors } from './config';
import Schedule from './Schedule';

export default class Tooltip {
  disabled = false;

  container;
  closeButton;
  visualReminderInterval;

  constructor(containerEl) {
    this.container = containerEl;
    this.closeButton = containerEl.querySelector(selectors.tooltip.closeButton);
    this.textContainer = containerEl.querySelector(
      selectors.tooltip.textContainer,
    );

    this.attachListeners();
  }

  disable() {
    this.close();
    this.disabled = true;
  }

  show() {
    if (this.disabled) return;

    this.container.ariaHidden = false;

    setTimeout(this.startVisualReminders.bind(this), TOOLTIP_NUDGE_INTERVAL);
  }

  close() {
    if (this.disabled) return;

    this.container.remove();
    Schedule.queueNextTooltipAppearance(Durations.ONE_DAY);
  }

  setText(text) {
    this.textContainer.textContent = text;
  }

  isClosed() {
    return this.container.dataset.closed === 'true';
  }

  startVisualReminders() {
    bounce(this.container, {
      distance: '15px',
      repeat: true,
      animation: {
        iterations: 3,
      },
    });
  }

  attachListeners() {
    this.closeButton.addEventListener('click', () => {
      this.close();
    });

    this.container.addEventListener('click', () => {
      this.close();
    });
  }
}
